export default __webpack_public_path__ + "static/home-bg-video-30e2e59deac52b53c02b99c98ad2fdcf.mp4";